<!-- 手机登录 -->
<template>
  <form class="LoginForm-Component login-sign-form">
    <!-- 国家/地区 -->
    <div class="form-put-title">{{ $t('lang108') }}</div>
    <country-select @on-change="countrySelectChange" />

    <!-- 电话号码 -->
    <div class="form-put-title">{{ $t('lang109') }}</div>
    <div class="phone-number-tab">
      <div class="phone-number-box">
        <p class="phone-number-prev">+{{ yourPhonePrevCode }}</p>
        <input v-model="yourPhoneNumber" @keyup.enter="login" />
      </div>
    </div>

    <!-- 密码 -->
    <div class="form-put-title">
      {{ $t('lang110') }}
      <a
        class="forgot-password"
        href="javascript:;"
        @click="$emit('go-other-form', 3)"
      >
        {{ $t('lang111') }}
      </a>
    </div>
    <div class="password-tab">
      <input v-model="password" type="password" @keyup.enter="login" />
    </div>

    <!-- 滑块验证 -->
    <div id="captcha-box-login" ref="captchaBox" class="captcha-box"></div>

    <!-- 协议 -->
    <policy
      :showAgreeTips="showAgreeTips"
      @hideAgreeTips="showAgreeTips = false"
      @emitAgree="emitAgree"
    />

    <!-- 登录按钮 -->
    <button
      :class="['btn-sumbit', { 'btn-loading': loading, 'btn-gray': btnGray }]"
      type="button"
      @click="login"
    >
      <span v-if="loading" class="icon-loading">
        <img :src="require('@assets/img/loading.gif')" />
      </span>
      {{ $t('lang038') }}
    </button>
  </form>
</template>

<script>
import getDeviceId from '@components/Player/deviceId';
import { statusCodeMapping } from '@constant';
import CountrySelect from './CountrySelect';
import Policy from './Policy';

// 手机登录密码错误次数
let loginFailTimes = 0;

export default {
  components: {
    CountrySelect,
    Policy
  },
  data() {
    return {
      yourCountryName: '',
      yourCountryCode: '',
      yourPhonePrevCode: '',
      yourPhoneNumber: '',
      password: '',
      captchaToken: '',
      // 手机登录 loading
      loading: false,
      // 是否同意隐私政策
      isAgree: true,
      showAgreeTips: false
    };
  },
  computed: {
    btnGray() {
      if (!this.yourPhoneNumber || !this.password) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    setTimeout(() => {
      this.initCaptcha();
    }, 0);
  },
  methods: {
    emitAgree(agree) {
      this.isAgree = agree;
    },
    async login() {
      if (!this.isAgree) {
        this.showAgreeTips = true;
        return;
      }

      const {
        yourPhoneNumber,
        password,
        yourPhonePrevCode,
        captchaToken
      } = this;
      let errorTips = '';

      if (yourPhoneNumber.length === 0) {
        /* eslint-disable prefer-destructuring */
        errorTips = statusCodeMapping[101];
      } else if (yourPhonePrevCode.length === 0) {
        errorTips = statusCodeMapping[100];
      } else if (password.length < 6) {
        errorTips = statusCodeMapping[109];
      } else if (!captchaToken) {
        errorTips = statusCodeMapping[102];
      }
      if (errorTips) return this.$toast(this.$t(errorTips));
      /* eslint-enable prefer-destructuring */
      const deviceId = await getDeviceId();
      const data = {
        interfaceName: 'login',
        is_third_party: 0,
        user: yourPhoneNumber,
        pwd: password,
        phone_code: yourPhonePrevCode,
        vcode: captchaToken,
        deviceId
      };
      this.loading = true;

      const res = await this.$api.login(data);

      const { code } = res || {};
      if (+code === 0) {
        this.$toast('Success');
        this.$log && this.$log.info('login success');
        window.location.reload();
      } else if (+code === 404) {
        this.$toast(this.$t(statusCodeMapping[code]));
        // 未注册，跳到注册弹窗
        setTimeout(() => {
          this.$emit('go-other-form', 1, yourPhoneNumber);
        }, 3000);
        this.$log && this.$log.error('login error', { msg: code });
      } else if (+code === 401) {
        this.$toast(this.$t(statusCodeMapping[code]));
        loginFailTimes += 1;
        // 密码错误三次触发手动滑块
        if (loginFailTimes >= 3) {
          this.captchaLogin.reinit();
          this.loading = false;
          // eslint-disable-next-line
          return;
        }
        this.initCaptcha();
        this.$log && this.$log.info('login error', { msg: code });
      } else {
        this.$toast(`${code}: login error`);
        this.initCaptcha();
        this.$log && this.$log.info('login error', { msg: code });
      }
      this.loading = false;
    },
    countrySelectChange(val) {
      const { countryName, countryCode, phonePrevCode } = val;
      this.yourCountryName = countryName;
      this.yourCountryCode = countryCode;
      this.yourPhonePrevCode = phonePrevCode;
    },
    // 登录校验滑块加载
    initCaptcha() {
      this.captchaLogin = new window.BigoCaptcha.Captcha();
      this.captchaLogin.initWithParams(
        {
          id: 'captcha-box-login',
          width: '300px',
          height: '40px',
          fontsize: '14px',
          business: 'bigolive-web',
          scene: 'login'
        },
        (res) => {
          if (res && res.status === 2) {
            this.captchaToken = res.token;
          }
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import './form.scss';

.forgot-password {
  float: right;
  font-size: 12px;
  font-weight: 400;
  color: #8a8f99;
  line-height: 14px;
  // text-decoration: underline;

  // &:focus {
  //   outline: 1px dotted rgb(139, 168, 180);
  // }
}

.captcha-box {
  margin-top: 20px;
}
</style>
